import {Episode} from '@app/titles/models/episode';
import {Title} from '@app/titles/models/title';

export function getDownloadLink(title?: Title, episode?: Episode): string {
  if (episode) {
    return (
      '/titles/' +
      episode.title_id +
      '/season/' +
      episode.season_number +
      '/episode/' +
      episode.episode_number +
      '/download'
    );
  } else {
    return getDownloadLinkTitle(title!.id);
  }
}

export function getDownloadLinkTitle(title_id: number): string {
  return '/titles/' + title_id + '/download';
}
